export default {
  created () {
    this.disableAllBar();
    if (this.getLocal('adminStatus') === '1') {
      this.openToolbarAuth();
    } else {
      this.setToolbarAuth();
    }
  },
  methods: {
    /* 禁用所有toolbar */
    disableAllBar () {
      this.toolBarList.forEach((item) => {
        item.authDisabled = true;
      });
    },
    /* 放开按钮权限 */
    openToolbarAuth () {
      this.toolBarList.forEach((item) => {
        item.authDisabled = false;
      });
    },
    /* 设置按钮权限 */
    setToolbarAuth () {
      let btnList = this.getLocal('btnList');
      btnList && btnList.forEach((el) => {
        if (this.$route.name === el.componentName) {
          this.toolBarList.forEach((item) => {
            item.key === el.key && (item.authDisabled = false);
          });
        }
      });
    }
  }
};
